<script>
import ErrorsPage from "./errors-page.vue";
export default {
    props: ["errorNetworkrErrorprops","error401props", "error500props", "errorOtherprops"],
    data: function () {
    return {
      errorNetworkrError: this.errorNetworkrErrorprops,
      error401: this.error401props,
      error500: this.error500props,
      errorOther: this.errorOtherprops,
    };
  },
  components: { ErrorsPage },
  name: "errors",
};
</script>

<template >
  <fragment>    
    <errors-page
      v-if="error401"
      errorCode="401"
      errorTitle="Unauthorized"
      errorDetail="You don't have specific permissions to access this application"
    ></errors-page>
    <errors-page
      v-if="errorNetworkrError"
      errorCode="networkError"
      errorTitle="Network Error"
      errorDetail="You are not connected to the Internet"
    ></errors-page>
    <errors-page
      v-if="error500"
      errorCode="500"
      errorTitle="Something went wrong"
      errorDetail="Please try again"
    ></errors-page>
    <errors-page
      v-if="errorOther"
      errorCode="other"
      errorTitle="Something went wrong"
      errorDetail="Please try again"
    ></errors-page>
  </fragment>
</template>